export const statusDropdown = [
    { '_id': 1, name: 'Active'},
    { '_id': 1, name: 'Inactive'},
    { '_id': 1, name: 'expried'},
    { '_id': 1, name: 'Deleted'},
];
